import React, { PropTypes } from 'react';
import selectionElementMode from '../selectionElementMode';
import SelectWithAddEditControl from '../SelectWithAddEditControl';
import { itemsPropTypes } from '../commonPropTypes';

const SelectWithAddEditControlView = React.createClass({
    propTypes: {
        label: PropTypes.string.isRequired,
        items: itemsPropTypes,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onModeChanged: PropTypes.func,
        addFormCreator: PropTypes.func.isRequired,
        setupNewLabel: PropTypes.string,
        autoFocus: PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            setupNewLabel: 'Setup New'
        };
    },
    getInitialState: function() {
        const { items, addFormCreator } = this.props;
        return {
            mode: items.length < 1 ? selectionElementMode.add : selectionElementMode.select,
            addForm: addFormCreator(this.onAddSuccess, this.onAddEditCancel)
        };
    },
    changeMode: function(mode) {
        const { onModeChanged } = this.props;
        this.setState({ mode: mode });
        if(onModeChanged) { onModeChanged(mode); }
    },
    onAddRequested: function () {
        this.changeMode(selectionElementMode.add);
    },
    onAddSuccess: function(added) {
        this.changeMode(selectionElementMode.select);
        this.props.onChange(added.id);
    },
    onAddEditCancel: function() {
        this.changeMode(selectionElementMode.select);
    },
    componentDidMount: function() {
        this.changeMode(this.state.mode);
    },
    render: function () {
        const { items, value, autoFocus, onChange, label, setupNewLabel } = this.props;
        const { mode, addForm } = this.state;

        return (
            <div>
                {mode === selectionElementMode.select && <div>
                    <label>{label}</label>
                    <SelectWithAddEditControl items={items} onChange={onChange} value={value} autoFocus={autoFocus} onAddClick={this.onAddRequested} setupNewLabel={setupNewLabel} />
                </div>}

                {(mode === selectionElementMode.add) && <div>{addForm}</div>}
            </div>
        );
    }
});

export default SelectWithAddEditControlView;



// WEBPACK FOOTER //
// ./src/components/common/SelectWithAddEditControlView/index.jsx